module.exports = __webpack_public_path__ + "img/exe.f7ece685.png";